import type { FC } from 'react';
import { Onboarding } from '@/components/onboarding/index.tsx';

export const OnboardingPage: FC = () => <Onboarding />;
